// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1WP6Y","rootSuccess":"CompleteLink_rootSuccess__2dfuN","rootFailure":"CompleteLink_rootFailure__2KE5G","isDisabled":"CompleteLink_isDisabled__3DS9Z"};